// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.articlesearch.article', {
        url: '/{articleId}',
        views: {
            "articleView@stock": {
                templateUrl: 'main/stock/articles/article/article.tpl.html',
                controller: 'StockArticleController as vm'
            }
        },
        resolve: {
            article: articleResolver,
            stocks: stocksResolver
        }
    });
}

// @ngInject
function articleResolver($stateParams, StockApiService) {
    return StockApiService.getProduct($stateParams.articleId);
}

// @ngInject
function stocksResolver($stateParams, StockApiService) {
    return StockApiService.getProductStock($stateParams.articleId);
}

// @ngInject
function StockArticleController($state, $window, $translate, article, stocks, AuthService, ArticleLabelsPrintDialogService) {
    var vm = this;
    console.log(article);
    //Properties
    vm.selectedArticle = article;
    vm.selectedArticleStocks = stocks;
    var variantsGrid = {};
    variantsGrid.columns = [];
    vm.rowData = [];
    vm.variantsGrid = [];
    vm.variantsGrid.columns = [];
    vm.selectedLocation = {};
    vm.selectedVariantDetail1 = {};
    vm.validationErrors = [];
    vm.lastVariant1RowClicked = {};
    vm.selectedFilter = {};
    vm.stocksLocations = pickOutUniqueLocations(stocks);
    vm.stocksVariant1s = _.sortBy(pickOutUniqueVarDetail1s(article.articleVariants), function(variant) { return variant.variantDetailName; });
    vm.locationFilter = angular.copy(vm.stocksLocations);
    vm.locationFilter.unshift({ id: -1, locationName: $translate.instant('common.all') });
    vm.selectedFilter.location = vm.locationFilter[0];
    vm.variantFilters = angular.copy(vm.stocksVariant1s);
    vm.variantFilters.unshift({ id: -1, variantDetailName: $translate.instant('common.all') });
    vm.selectedFilter.variant = vm.variantFilters[0];
    vm.shouldDisplayDetails = false;

    //Properties
    vm.selectedVariantDetailChanged = selectedVariantDetailChanged;
    vm.setSelectedLocationAndVariant1 = setSelectedLocationAndVariant1;
    vm.filterRowData = filterRowData;
    vm.shouldShowDetails = shouldShowDetails;
    vm.getColumnSum = getColumnSum;
    vm.getTotalSum = getTotalSum;

    vm.shouldHaveIsCurrentStyle = shouldHaveIsCurrentStyle;
    vm.shouldNotHaveIsCurrentStyle = shouldNotHaveIsCurrentStyle;

    vm.openLabelsModal = openLabelsModal;
    
    vm.canAccess = AuthService.canAccess;
    vm.mayReadStockLogistics = AuthService.canAccess('stockLogistics', 'read');
    
    vm.productStateGo = productStateGo;

    updateVariantsGridData();

    function openLabelsModal() {
        ArticleLabelsPrintDialogService.showDialog(vm.selectedArticle.id);
    }

    function selectedVariantDetailChanged(sender) {
        vm.selectedVariantDetail1 = sender.selectedItem;
    }

    function setSelectedLocationAndVariant1(row) {
        if (!row.showHistory) {
            vm.lastVariant1RowClicked = {
                selectedVariantDetail1id: row.variantDetails1Id,
                selectedLocationId: row.location.id
            };
            vm.selectedVariantDetail1.id = row.variantDetails1Id;
            vm.selectedLocation.id = row.location.id;
            row.showHistory = true;
        } else if (row.showHistory &&
            vm.lastVariant1RowClicked.selectedVariantDetail1id === row.variantDetails1Id &&
            vm.lastVariant1RowClicked.selectedLocationId === row.location.id) {
            vm.lastVariant1RowClicked = {
                selectedVariantDetail1id: row.variantDetails1Id,
                selectedLocationId: row.location.id
            };
            row.showHistory = false;
        } else {
            vm.selectedVariantDetail1.id = row.variantDetails1Id;
            vm.selectedLocation.id = row.location.id;
        }
    }

    function updateVariantsGridData() {
        var variantDetail1s = [];
        var variantDetail2s = [];

        _.each(vm.selectedArticle.articleVariants, function(articleVariant) {
            variantDetail1s.push(articleVariant.variantDetail1);
            variantDetail2s.push(articleVariant.variantDetail2);
        });

       variantDetail1s = _.uniqBy(variantDetail1s, function(detail) {
            return detail.id; // Compare by ID
        });
        variantDetail2s = _.uniqBy(variantDetail2s, function(detail) {
            return detail.id; // Compare by ID
        });

        variantDetail1s = _.sortBy(variantDetail1s, function(detail) { return detail.variantDetailName; });
        variantDetail2s = _.sortBy(variantDetail2s, function(detail) { return detail.sortOrder; });

        vm.variantsGrid.columns = [];

        // Add first row header column
        // vm.variantsGrid.columns.push({ id: "locationName", name: $translate.instant('location.location') });
        // vm.variantsGrid.columns.push({ id: "variantDetails1Name", name: $translate.instant('article.variant') });

        _.each(variantDetail2s, function(varDetail2) {
            vm.variantsGrid.columns.push({ id: varDetail2.variantDetailName, name: varDetail2.variantDetailName });
        });

        // vm.variantsGrid.columns.push({ id: "sum", name: $translate.instant('stock.sumQuantity') });

        loadVariantsGridData();
    }

    function loadVariantsGridData() {
        vm.rowData = [];
        var currentLocationStocks = vm.selectedArticleStocks;

        var variantRows = _.groupBy(vm.selectedArticle.articleVariants, function(variant) {
            return variant.variantDetail1.id;
        });
        var locations = vm.stocksLocations;
        locations = _.sortBy(locations, function(location) { return location.locationNumber; });

        _.each(locations, function(location) {
            _.each(variantRows, function(variantRowValues) {
                var r = {};
                r.sum = 0;
                r.orderedSum = 0;
                r.reservedSum = 0;
                r.showHistory = false;

                //Get variant stock quantities
                _.each(variantRowValues, function(variantRowValue) {
                    var relatedStock = _.find(currentLocationStocks, function(stock) { return stock.articleVariant.id === variantRowValue.id && stock.location.id === location.id; });
                    r.variantDetails1Name = variantRowValue.variantDetail1.variantDetailName;
                    r.variantDetails1Id = variantRowValue.variantDetail1.id;
                    r.IsCurrent = variantRowValue.isCurrent; 
                    r.currentRank = variantRowValue.articleCollection.currentRank;
                    if (relatedStock !== undefined) {
                        if (!r[variantRowValue.variantDetail2.variantDetailName]) {
                            r[variantRowValue.variantDetail2.variantDetailName] = {};
                            r[variantRowValue.variantDetail2.variantDetailName].quantity = 0;
                            r[variantRowValue.variantDetail2.variantDetailName].orderedQuantity = 0;
                            r[variantRowValue.variantDetail2.variantDetailName].reservedQuantity = 0;
                        }
                        r[variantRowValue.variantDetail2.variantDetailName].quantity += relatedStock.quantity;
                        r[variantRowValue.variantDetail2.variantDetailName].orderedQuantity += relatedStock.orderedQuantity;
                        r[variantRowValue.variantDetail2.variantDetailName].reservedQuantity += relatedStock.reservedQuantity;
                        r.sum += relatedStock.quantity;
                        r.orderedSum += relatedStock.orderedQuantity;
                        r.reservedSum += relatedStock.reservedQuantity;
                    }
                });

                //Get variant location names
                r.locationName = location.locationName;
                r.location = location;

                vm.rowData.push(r);
                console.log(r);
            });
        });
    }


    function pickOutUniqueLocations(stocks) {
       var locations = [];
        _.each(stocks, function(stock) {
            var unique = true;
            _.each(locations, function(location) {
                if (sameLocation(location, stock.location)) {
                    unique = false;
                }
            });
            if (unique) {
                locations.push(stock.location);
            }
        });
        return locations;
    }

    function pickOutUniqueVarDetail1s(articleVariants) {
        var varDetail1s = [];
        _.forEach(articleVariants, function(artVar) {
            varDetail1s.push(artVar.variantDetail1);
        });
        varDetail1s = _.uniqBy(varDetail1s, function(detail) {
            return detail.id;
        });
        return varDetail1s;
    }

    function sameLocation(location1, location2) {
        if (location1.id === location2.id) {
            return true;
        }
        return false;
    }

    function filterRowData(row) {
        return (vm.selectedFilter.location.id === -1 ||
                    row.location.locationName === vm.selectedFilter.location.locationName) &&
               (vm.selectedFilter.variant.id === -1 ||
                    row.variantDetails1Name === vm.selectedFilter.variant.variantDetailName);
    }

    function shouldShowDetails(row) {
        return row.showHistory && vm.selectedVariantDetail1.id === row.variantDetails1Id && vm.selectedLocation.id === row.location.id;
    }

    function getColumnSum(col) {
        var sum = _.sumBy(vm.rowData, function(o) {
            if (vm.filterRowData(o) && o[col.id]) {
                return o[col.id].quantity;
            } else {
                return 0;
            }
        });

        return sum;
    }

    function getTotalSum() 
    {
        var sum = 0;
        _.forEach(vm.rowData, function(r) {
            sum += r.sum;
        });
        return sum;
    }

    function shouldHaveIsCurrentStyle(row) 
    {
        if (!row) { return false; }
        return row.IsCurrent === true;
    }

    function shouldNotHaveIsCurrentStyle(row) {
        if (!row) { return false; }
        return row.IsCurrent === false && (row.currentRank < 0);
    }

    function productStateGo(stringState){
        $state.go(stringState, 
            {
                articleId: vm.selectedArticle.id,
                filter: $state.params.filter,
                currentPage:  $state.params.currentPage,
                pageSize:  $state.params.pageSize,
                inactive:  $state.params.inactive,
                match:  $state.params.match
            }
        );
    }
}

angular.module('stock.articles.article', [])
    .config(stateConfig)
    .controller('StockArticleController', StockArticleController);
